import { InventoryType } from "@/global/store/data/types";
import { AiOutlineDollarCircle } from "react-icons/ai";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";
import { howItWorks, faqs, CheckoutTerms } from "./helpers";
import { TbShirtSport } from "react-icons/tb";
import FindGamesBanner from "public/images/magic/magic_ChooseYourGamesBanner.jpeg";
import GiftCardBanner from "@/assets/images/brandedCalloutBg.jpg";
import { routes } from "@/global/routes";
import { vendorUUIDs } from "../../constants";
import { TeamConfig } from "../types";

// featured game card image : 350x180

const config: TeamConfig = {
  teamSchema: "tdc_flex_certification",
  browserTitle: "Flex Sandbox",
  packages: false,
  teamName: "Flex Sandbox",

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: true,
    redirectGiftCardUrl: routes.giftCard,
  },

  // disabled routes
  disabledRoutes: [],

  defaultRoute: routes.purchaseSeats,
  seatMapVenueId: "nam-us-10215-devils-sec",
  phoneNumber: "",

  // seat map configs
  seatMapConfigs: {
    venueId: "",
    mapId: "",
  },

  checkoutCreditPackages: false,
  availableCreditEnabled: true,
  isCrowdHandlerEnabled: false,
  inventoryType: "SEAT-LEVEL",

  // purchase seats config
  purchaseSeatConfigs: {
    minGameSelectionCount: 1,
    minSeatLimit: 1,
    isSimilarSeatForAllEvents: false,
    isCheckoutEditSeatsEnabled: false,
    isDiffSeatAlertEnabled: false,
    showFrontendTotalAmount: true,
    showFrontendServiceFee: true,
    allowManualCartInSimilar: false,
    isPerksEnabled: true,
  },

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: false,
    allowedPages: [],
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: true,
    isStandAlonePurchaseCreditEnabled: true,
    showPurchaseCreditLinkInHomeMenu: true,
    isPurchaseCreditHistoryEnabled: false,
    checkoutTimerEnabled: true,
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: Infinity,
    allowedPaymentFailCount: Infinity,
  },
  isSaveCardAllowed: true,

  isBrainTreePaymentEnabled: true,

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "",
    attrkPixelId: "",
    beaconId: "",
  },

  // call refresh inventory when selecting games
  refreshInventoryWhenEventClick: false,

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl: "",
    externalRedirectUrl: "",
  },

  // urls
  accountManagerUrl: "https://am.ticketmaster.com/baabal/",

  // vendor
  platform: vendorUUIDs.tickesdotcom,

  // okta config
  oktaIssuer: "https://integrator-3404041.okta.com", // dev okta creds
  oktaClientId: "0oayigvuniVNS5aTO697", // dev okta creds
  shouldUseInternalLogin: true,

  images: {
    findGamesBannerImage: FindGamesBanner.src,
    authBackgroundImage: "",
    checkoutStatusPageImage: "",
    //TODO: update const to the other teams
    giftCardStandalonePageImage: GiftCardBanner.src,
    logoImage:
      "http://ss-leagues.s3.amazonaws.com/NBA/Updated%20NBA%20Logos/orl.png?width=76&height=76",
    logoNameImage: "",
    faviconImage: "",
    seatMap3dPreviewImage: "",
  },

  colors: {
    primary: "#0077c0",
  },

  howItWorks,
  faqs,

  uiConfigs: {
    bannerImage: {
      title: "Choose Your Games",
      isBackgroundBasedBanner: true,
    },
    featuredGameCard: {
      showLogoWithTitle: false,
      hideOverlayLogo: false,
    },

    bottomBar: {
      showGameSelectionProgress: false,
    },
  },

  languages: {
    topNavMenuItems: <></>,
    checkoutTermsAndCondition: <CheckoutTerms />,
    registrationTermsAndCondition: <CheckoutTerms />,
    purchaseGiftCard: null,
    redeemGiftCard: null,
    purchaseSeats: null,
    giftCard: {
      title: "",
      createGiftCard: {
        description: "",
        recipient: {
          sendNowFalse: {
            description:
              "If an intended recipient is not specified, once purchased, you will have to forward the unique code to the recipient. Upon your recipient receiving their gift card, they will be prompted to enter their unique code to redeem the gift card. They can use the gift card for all events at the Hippodrome Broadway Series in Baltimore, Maryland.",
          },
          sendNowTrue: {
            description:
              "The Recipient will be sent an email with the unique code for them to redeem their gift card. They can use the gift card for all events at the Hippodrome Broadway Series in Baltimore, Maryland.",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description:
            "Please input the case sensitive unique code provided to redeem the value of the gift card to the Ticketmaster account above.",
        },
        logout: {
          description:
            "Please input the case sensitive unique code provided to redeem the value of the gift card to the Ticketmaster.",
        },
        success: {
          description: "has been added to to yout account!",
        },
      },
    },
    signInAuthText:
      "Connect your mlb.com account to continue with seamless access.",
  },
};

export default config;
